module.exports = __webpack_public_path__ + "static/media/medio_camion.729f5ab1.svg";